export default __webpack_public_path__ + "static/media/menu_top_users_okara.eab880b0.svg";